var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 8,
    viewBox: "0 0 20 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75774 0C6.1635 0 2.78508 0.755371 1.10002 2.44043C0.336351 3.2041 -0.0454851 4.12549 0.00431963 5.23779C0.0375228 5.91016 0.245042 6.50781 0.635179 6.89795C0.925706 7.19678 1.33244 7.36279 1.80559 7.28809L4.88518 6.76514C5.35002 6.69043 5.67375 6.54932 5.88127 6.3335C6.1552 6.06787 6.23821 5.66943 6.23821 5.14648V4.30811C6.23821 4.17529 6.29631 4.07568 6.37932 3.99268C6.46233 3.89307 6.58684 3.85156 6.67815 3.82666C7.2426 3.69385 8.38811 3.56934 9.75774 3.56934C11.1274 3.56934 12.2646 3.66895 12.8373 3.83496C12.9203 3.85986 13.0365 3.90967 13.1279 3.99268C13.2026 4.07568 13.2524 4.16699 13.2607 4.2998L13.269 5.14648C13.2773 5.66943 13.3603 6.06787 13.6259 6.3335C13.8417 6.54932 14.1655 6.69043 14.6303 6.76514L17.6684 7.27979C18.1581 7.36279 18.5732 7.18848 18.8969 6.87305C19.287 6.49121 19.5029 5.90186 19.5195 5.22949C19.5444 4.10889 19.1127 3.1875 18.3656 2.44043C16.6806 0.755371 13.352 0 9.75774 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneDown);
export default __webpack_public_path__ + "static/media/phone_down.9c698ccf535c7486fbad945b3b2e4e52.svg";
export { ForwardRef as ReactComponent };